// Core Components
import React, { useEffect } from 'react';
import { Link, Route, Switch } from 'react-router-dom';

// Material UI Components
import { Tabs, Tab } from '@mui/material';

import LibraryIcon from '@mui/icons-material/AutoStories';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DataIcon from '@mui/icons-material/InsertChart';
import { RealEstateAgentIcon } from 'global/components/PerformIcons';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import SettingsIcon from '@mui/icons-material/Settings';

// PERFORM Components
import TabContainer from 'global/components/TabContainer';
import PageTitle from 'global/components/PageTitle';
import Profile from 'feature/user/profile';
import ManageUsers from 'feature/user/manage';
import UserCourses from 'feature/user/courses';
import CreateUsers from 'feature/user/create';
import AccountSettings from './account-settings';
import Alerts from 'feature/user/alerts';
import Vendors from './vendors';
import Content from './content';
import { ManageData } from './manage-data';

export function UsersPage(props) {
  useEffect(() => {
    props.changeTitle(<PageTitle Icon={SupervisedUserCircleIcon} title="Users" />);
  }, []);

  useEffect(() => {
    if (props.location.pathname === '/users') {
      props.history.push(`users/manage`);
    }
  }, [props.location]);

  return (
    <>
      <Tabs value={props.match.params.display ?? false} centered indicatorColor="secondary" textColor="secondary">
        <Tab component={Link} to={`${'manage'}`} icon={<PeopleIcon />} label={'Manage'} value={'manage'} key={0} />
        <Tab component={Link} to={`${'create'}`} icon={<PersonAddIcon />} label={'Create'} value={'create'} key={1} />
        <Tab component={Link} to={`${'courses'}`} icon={<MenuBookIcon />} label={'Courses'} value={'courses'} key={2} />
      </Tabs>
      <Switch>
        <Route
          exact
          path="/users/manage"
          render={(match) => (
            <TabContainer key={0}>
              <ManageUsers />
            </TabContainer>
          )}
        />
        <Route
          exact
          path="/users/create"
          render={(match) => (
            <TabContainer key={1}>
              <CreateUsers />
            </TabContainer>
          )}
        />
        <Route
          exact
          path="/users/courses"
          render={(match) => (
            <TabContainer key={2}>
              <UserCourses />
            </TabContainer>
          )}
        />
      </Switch>
    </>
  );
}

export function AccountPage(props) {
  useEffect(() => {
    props.changeTitle(<PageTitle Icon={SettingsIcon} title="Account" />);
  }, []);

  useEffect(() => {
    if (props.location.pathname === '/account') {
      props.history.push(`account/settings`);
    }
  }, [props.location]);

  return (
    <>
      <Tabs value={props.match.params.display ?? false} centered indicatorColor="secondary" textColor="secondary">
        <Tab component={Link} to={`${'content'}`} icon={<LibraryIcon />} label={'Content'} value={'content'} key={0} />
        <Tab component={Link} to={`${'settings'}`} icon={<SettingsIcon />} label={'Settings'} value={'settings'} key={1} />
        <Tab component={Link} to={`${'vendors'}`} icon={<RealEstateAgentIcon />} label={'Vendors'} value={'vendors'} key={2} />
        <Tab component={Link} to={`${"data"}`} icon={<DataIcon />} label={"Data"} value={"data"} key={3}/>
      </Tabs>
      <Switch>
        <Route
          exact
          path="/account/content"
          render={(match) => (
            <TabContainer key={0}>
              <Content allowedPermissions={['manageAccount']} />
            </TabContainer>
          )}
        />
        <Route
          exact
          path="/account/settings"
          render={(match) => (
            <TabContainer key={1}>
              <AccountSettings allowedPermissions={['manageAccount']} />
            </TabContainer>
          )}
        />
        <Route
          exact
          path="/account/vendors"
          render={(match) => (
            <TabContainer key={2}>
              <Vendors allowedPermissions={['manageAccount']} />
            </TabContainer>
          )}
        />
        <Route exact path="/account/data" render={(match) => <TabContainer key={3}><ManageData allowedPermissions={['manageAccount']} /></TabContainer>} />
      </Switch>
    </>
  );
}

export function ProfilePage(props) {
  useEffect(() => {
    props.changeTitle(<PageTitle Icon={AccountCircleIcon} title="Profile" />);
  }, []);

  return <Profile />;
}

export function AlertsPage(props) {
  useEffect(() => {
    props.changeTitle(<PageTitle Icon={NotificationsActiveIcon} title="Alerts" />);
  }, []);

  useEffect(() => {
    if (props.location.pathname === '/alerts') {
      props.history.push(`alerts/user`);
    }
  }, [props.location]);

  return (
    <>
      <Tabs value={props.match.params.display ?? false} centered indicatorColor="secondary" textColor="secondary">
        <Tab component={Link} to={`user`} icon={<PersonIcon />} label={'My Alerts'} value={'user'} key={0} />
        <Tab component={Link} to={`all`} icon={<PeopleIcon />} label={'All Alerts'} value={'all'} key={1} />
      </Tabs>
      <Switch>
        <Route
          exact
          path="/alerts/user"
          render={(match) => (
            <TabContainer key={0}>
              <Alerts {...match} />
            </TabContainer>
          )}
        />
        <Route
          exact
          path="/alerts/all"
          render={(match) => (
            <TabContainer key={1}>
              <Alerts {...match} />
            </TabContainer>
          )}
        />
      </Switch>
    </>
  );
}
